<template>
  <div ref="nav" :class="['nav-menu']">
    <div :class="[isFileManager ? 'file-layout' : 'nav-content']">
      <div :id="appNavigatorContainerId" class="file-nav"></div>
      <template v-if="isFileManager">
        <template v-for="menu in menuList">
          <template v-for="appInfo in menu.appMenuList" :key="appInfo.id">
            <div class="item-nav" v-if="!appInfo.hasSubNavigation">
              <div
                :class="['menu-item', appInfo.id === activeAppId ? 'active-item' : '']"
                @click="onCategoryItemClicked(appInfo)"
              >
                {{ appInfo.name }}
              </div>
            </div>
          </template>
        </template>
      </template>
    </div>
  </div>
</template>
<script lang="ts" setup>
  import { onMounted, shallowRef, watchEffect, ref, onUnmounted } from 'vue'
  import router from '@/router'
  import { INSTANCE as ApplicationManager } from '@core/application/ApplicationManager'
  import type { AppInfo } from '@core/application/ApplicationManager'
  import type { AppMenuInfo } from '@core/menus/MenuManager'
  import { INSTANCE as menuManager } from '@core/menus/MenuManager'
  import { PATH_SEPARATOR, Router as RouterConstant, TimeConstants } from '@core/Constants'
  import { debounce, isString } from 'lodash'
  import { useMicroAppContainer } from '@/core/compositions/MicroAppContainer'
  import { useSharedActiveMenuItem } from '@/core/compositions/ActiveMenuItem'
  import { AppCategory } from '@/core/application/ApplicationConstants'

  const { activeAppId, isFileManager } = useSharedActiveMenuItem()
  const { appNavigatorContainerId } = useMicroAppContainer()
  let menuList = shallowRef<AppMenuInfo[]>([])
  const PREFIX_SUB_NAVIGATOR = 'sub_nav_' // used for distinguish whether the menu item is a sub-navigator micro APP

  const onCategoryItemClicked = debounce(
    (item: AppInfo) => {
      if (isString(item.id) && item.id.startsWith(PREFIX_SUB_NAVIGATOR)) {
        return
      }
      const route = Array.of('', RouterConstant.MICRO_APP_MAIN, item.id).join(PATH_SEPARATOR)

      // 已触发router push不再触发
      if (location.pathname.includes(route)) return

      console.log(`router push: ${route}`)

      router.push(route)
    },
    TimeConstants.FASTER_DEBOUNCING_IN_MS,
    { leading: true, trailing: false }
  )
  // 观察nav的宽度变化
  const nav = ref<HTMLDivElement>()

  onMounted(() => {
    if (nav.value) {
      if (nav.value.offsetWidth < 1024) {
        nav.value.classList.add('small-nav')
      }
    }
    // 如果需要监听窗口大小变化
    const handleResize = () => {
      if (nav.value) {
        if (nav.value.offsetWidth < 1024) {
          nav.value.classList.add('small-nav')
        } else {
          nav.value.classList.remove('small-nav')
        }
      }
    }

    window.addEventListener('resize', handleResize)

    // 组件卸载时移除事件监听器
    onUnmounted(() => {
      window.removeEventListener('resize', handleResize)
    })
    menuManager.init(ApplicationManager.getAppList())
    menuList.value = menuManager
      .getMenuList()
      .filter(({ category }) => category === AppCategory.FILE)
      .map((item) => {
        item.name = ApplicationManager.getCategoryNameByType(item.category)

        return item
      })
  })
</script>
<style scoped lang="stylus">

  ::-webkit-scrollbar
    display none

  nav-bar-active-hover-item()
    opacity 1
    border-bottom 2px solid default_color
  .nav-menu
    rect(100%)
    .menu-item
      cursor pointer
      font-weight bolder_font_weight
      color default_color
      font-size 16px
      padding 20px 0 17px
      border-bottom 2px solid transparent
      opacity 0.8
      &:hover
        nav-bar-active-hover-item()
    .active-item
      nav-bar-active-hover-item()
  // .file-layout
  //   flex-align-center(space-around)
  //   padding 0 20%
  //   box-sizing border-box
    .file-layout
      flex-align-center(space-around)
      // padding 0 20%
      max-width : 1024px
      box-sizing border-box
      .file-nav
        width: 293.33px
        margin-left: 48px
        display: flex
        justify-content: center
      .item-nav
        width: 293.33px
        margin-left: 24px
        display: flex
        justify-content: center
        &:last-child
          margin-right: 48px
    .limit-content
      width:100%
  .small-nav
    .file-layout
      width: 100% !important
      .file-nav
        flex: 1
        width: auto !important
      .item-nav
        flex: 1
        width: auto !important
  @import '../styles/h5Adaptive/NavigationBar.styl'
</style>
